import { schema } from 'normalizr';

const position = new schema.Entity('positions');

const employee = new schema.Entity('employees', {
  position,
});
export const employees = [employee];

const shift = new schema.Entity('shifts', {
  employees,
  position,
});

export const shifts = [shift];



// WEBPACK FOOTER //
// ./src/actions/schema.js